(() => {
    let
        idx = 0,
        fallbackTabIndex = 0;
    const
        defaultItemText = "name"

    class FilteredChecklist {
        filterInputId = `filter-input-${idx++}`;
        toggleShowOnlySelectedText = "Show selected";

        _showOnlySelectedItems = false;
        /**
         * @type { HTMLElement | undefined }
         */
        element;

        /**
         * @type FilteredCheckListOptions
         */
        _options;
        get options() {
            return this._options;
        }

        set options(value) {
            this._options = value;
            if (!value) {
                return;
            }
            if (!value.itemText) {
                value.itemText = defaultItemText;
            }
            let treatAsKey = typeof value.itemText === "string";
            this.textFor = treatAsKey
                ? this.textForItemByKey.bind(this)
                : this.textForItemByGenerator.bind(this);
            if (!value.itemTitle) {
                this.titleFor = this.noTitle.bind(this);
            } else {
                treatAsKey = typeof value.itemTitle === "string";
                this.titleFor = treatAsKey
                    ? this.titleForItemByKey.bind(this)
                    : this.titleForItemByGenerator.bind(this);
            }
            if (!this.options.selectAllText) {
                this.options.selectAllText = "Select All"
            }
        }

        noTitle() {
            return "";
        }

        tabIndexFor(item) {
            if (!this.options || !this.options.source) {
                return ++fallbackTabIndex;
            }
            return this.options.source.indexOf(item);
        }

        showOnlySelectedItems = false;

        /**
         * @type {((o: any) => string)}
         */
        textFor

        /**
         * @type {((o: any) => string)}
         */
        titleFor

        generateTextFor(item) {
            return this.textFor(item) || "";
        }

        get filteredItems() {
            if (!Array.isArray(this.options.source)) {
                return [];
            }
            return this.options.source.filter(
                o => {
                    if (this._showOnlySelectedItems && !this.isSelected(o)) {
                        return false;
                    }
                    const words = `${this._filterText}`
                        .trim()
                        .toLowerCase()
                        .split(/\b/);
                    const lowerText = this.generateTextFor(o).toLowerCase();
                    for (const word of words) {
                        if (!lowerText.includes(word)) {
                            return false;
                        }
                    }
                    return true;
                }
            );
        }

        _filterText = "";
        get filterText() {
            return this._filterText;
        }

        set filterText(value) {
            this._filterText = value;
        }

        get selectedItemsText() {
            const
                count = (this.options.target || []).length;
            return `${count} selected`
        }

        constructor(
            $scope,
            $element
        ) {
            this.$scope = $scope;
            this.element = $element[0];
        }

        isSelected(item) {
            if (!Array.isArray(this.options.target)) {
                return false;
            }
            return this.options.target.includes(item);
        }

        /**
         * @param { any } item
         * @param {KeyboardEvent} [ev]
         */
        toggleSelected(item, ev) {
            if (!this.options) {
                return;
            }
            if (!this.options.target) {
                throw new Error(`'selected-items' must have an array passed in to collect selected items`);
            }
            if (!Array.isArray(this.options.target)) {
                throw new Error(`value bound to 'selected-items' is not an array`);
            }
            if (this.isSelected(item)) {
                let idx = this.options.target.indexOf(item);
                do {
                    this.options.target.splice(idx, 1);
                    idx = this.options.target.indexOf(item);
                } while (idx > -1);
            } else {
                this.options.target.push(item);
            }
            this.mute(ev);
        }

        textForItemByKey(item) {
            return this.textForItemByProp(
                item,
                this.options.itemText
            );
        }

        titleForItemByKey(item) {
            return this.textForItemByProp(
                item,
                this.options.itemTitle
            );
        }

        textForItemByProp(item, prop) {
            if (!this.options) {
                return item;
            }
            const
                result = item[prop];
            if (!result) {
                let reportedValue;
                switch (result) {
                    case "":
                        reportedValue = "empty string";
                        break;
                    case undefined:
                        reportedValue = "undefined";
                        break;
                    case null:
                        reportedValue = "null";
                        break;
                    default:
                        reportedValue = `(unknown): '${result}'`;
                        break;
                }
                console.warn(`property '${prop}' currently has value: ${reportedValue}`);
            }
            return result;
        }

        titleForItemByGenerator(item) {
            if (!this.options) {
                return item;
            }
            return this.options.itemTitle(item);
        }

        textForItemByGenerator(item) {
            if (!this.options) {
                return item;
            }
            return this.options.itemText(item);
        }

        selectAll() {
            const
                filteredItems = this.filteredItems,
                unselected = filteredItems.filter(
                    item => !this.isSelected(item)
                );
            this.options.target.push(...unselected);
        }

        selectNone() {
            const
                filteredItems = this.filteredItems,
                selected = filteredItems.filter(
                    item => this.isSelected(item)
                );
            for (const item of selected) {
                const idx = this.options.target.indexOf(item);
                if (idx > -1) {
                    this.options.target.splice(idx, 1);
                }
            }
        }

        toggleShowOnlySelected() {
            this.showOnlySelectedItems = !this.showOnlySelectedItems;
            this.toggleShowOnlySelectedText = this.showOnlySelectedItems
                ? "Show all"
                : "Show selected";
            this._showOnlySelectedItems = !this._showOnlySelectedItems;
        }

        _objectIds = new WeakMap();

        idFor(o) {
            const alreadyAllocated = this._objectIds.get(o);
            if (alreadyAllocated !== undefined) {
                return alreadyAllocated;
            }
            const result = `list-item-${++idx}`;
            this._objectIds.set(o, result);
            return result;
        }

        showOnlySelectedDisabled() {
            if (!this.options || !this.options.source || this.options.source.length === 0) {
                return undefined;
            }
            const isAllowed = this.options.target.length &&
                this.options.source.length !== this.options.target.length
            return isAllowed
                ? undefined
                : "disabled";
        }

        onFilterTextKeydown(ev) {
            if (ev.code === "ArrowDown") {
                const target = this.element.querySelector(
                    ".filtered-checklist-item"
                );
                if (target) {
                    target.focus();
                }
                this.mute(ev);
            } else if (ev.code === "Escape") {
                this.filterText = "";
                this.mute(ev);
            }
        }

        focus(item) {
            const idx = this.options.source.indexOf(item);
            if (idx < 0) {
                return;
            }
            const listElements = Array.from(
                this.element.querySelectorAll(
                    ".filtered-checklist-item"
                )
            );
            if (idx < listElements.length) {
                listElements[idx].focus();
            }
        }

        onListItemKeydown(ev, currentItem) {
            if (ev.code === "ArrowDown") {
                this.tryFocusNextItemInList(currentItem, ev);
            } else if (ev.code === "ArrowUp") {
                this.tryFocusPreviousItemInList(currentItem, ev);
            } else if (ev.code === "Space") {
                this.toggleSelected(currentItem, ev);
            }
        }

        /**
         * @param {KeyboardEvent} [ev]
         */
        clearFilter(ev) {
            this.filterText = "";
            this.mute(ev);
        }

        tryFocusNextItemInList(item, ev) {
            this.tryFocusItemInList(item, 1, ev);
        }

        tryFocusPreviousItemInList(item, ev) {
            if (!this.tryFocusItemInList(item, -1, ev)) {
                const filterInput = this.element.querySelector(
                    ".filtered-checklist-filter-input"
                );
                if (filterInput) {
                    filterInput.focus();
                }
            }
        }

        /**
         * @param {any} currentItem
         * @param {number} offset
         * @param {KeyboardEvent} [ev]
         * @returns {boolean} whether or not an item was focused
         */
        tryFocusItemInList(currentItem, offset, ev) {
            const idx = this.options.source.indexOf(currentItem);
            if (idx + offset < 0 || idx + offset >= this.options.source.length) {
                ev.stopPropagation();
                ev.preventDefault();
                return false;
            }
            const listElements = Array.from(
                this.element.querySelectorAll(
                    ".filtered-checklist-item"
                )
            );
            listElements[idx + offset].focus();
            this.mute(ev);
            return true;
        }

        mute(ev) {
            if (ev) {
                ev.stopPropagation();
                ev.preventDefault();
            }
        }
    }

    /**
     * @typedef FilteredCheckListOptions
     * @prop {string} [heading]
     * @prop {string} [label]
     * @prop {any[]} source
     * @prop {any[]} target
     * @prop {string | ((o: any) => string)} itemText
     * @prop {string | ((o: any) => string)} itemTitle
     * @prop {string} [selectAllText]
     * @prop {string} [selectNoneText]
     */

    angular.module("dashboard")
        .component("filteredChecklist", {
            templateUrl: "components/shared/filtered-checklist.572c7f10.html",
            bindings: {
                // options should be of type FilteredListOptions
                options: "<",
                ngDisabled: "<"
            },
            controller: [
                "$scope",
                "$element",
                FilteredChecklist
            ]

        });
})();
